import vars from '../helpers';

function init(container) {
	gsap.timeline()
		.from($(container).find('.home__item'), {
			autoAlpha: 0,
			clearProps: 'all',
			stagger: 0.3,
			onStart: () => {
				$(container).find('.home__item').removeClass('is-hide');
			},
		});

	// if (vars.$document.find('.home__container').height() > vars.$document.find('.home__inner').height()) {
	// 	vars.$document.find('.home').css('height', '100%');
	// }
}

function destroy(container) {
	$(container).find('.category-item').off('.home');
	$(container).find('.home__image').off('.home');
}

export default {
	init,
	destroy,
};
